import { render, staticRenderFns } from "./CardTaskItemReadOnly.vue?vue&type=template&id=e254bd56&scoped=true&"
import script from "./CardTaskItemReadOnly.vue?vue&type=script&lang=js&"
export * from "./CardTaskItemReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./CardTaskItemReadOnly.vue?vue&type=style&index=0&id=e254bd56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e254bd56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCardTitle,VRow,VTextField})
